import { DAY_IN_SECONDS } from '@vaultsfyi/common/constants'

export const formatTimeToMaturity = (expiry: number, currentTimestamp: number) => {
  const secondsRemaining = expiry - currentTimestamp
  const daysRemaining = Math.max(0, Math.ceil(secondsRemaining / DAY_IN_SECONDS))

  return `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'}`
}
